import {ReactComponent as ProfileIcon} from "../assets/icons/profile.svg";
import {ReactComponent as LocationIcon} from "../assets/icons/location.svg";
import {ReactComponent as WalletIcon} from "../assets/icons/wallet.svg";
import {ReactComponent as Messages} from "../assets/icons/Messages3.svg";
import {ReactComponent as Menu} from "../assets/icons/rules.svg";
import {ReactComponent as Folder} from "../assets/icons/direct.svg";

const routes = [
    {path: "/orders", label: "سفارشات", icon: <ProfileIcon/>},
    {path: "/products-menu", label: "منو محصولات", icon: <Menu/>},
    {path: "/financial-transactions", label: "تراکنش‌های مالی", icon: <WalletIcon/>},
    {path: "/comments", label: "نظرات کاربران", icon: <Messages/>},
    {path: "/reports", label: "گزارشات", icon: <LocationIcon/>},
    {path: "/off", label: "تخفیفات", icon: <Folder/>},
];

export default routes